// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"SheetColorsSelector_moreButton__zgL9O","more":"SheetColorsSelector_more__RwtjH","selected":"SheetColorsSelector_selected__tdu2N"};